export enum ElementClasses {
  ElementBody = 'element__body',
  ElementText = 'element__text',
}

export enum ContainerElementClasses {
  ContainerBody = 'element--container__body',
  ContainerSubactionBody = 'element--container__subaction__body',
  ContainerSubdecisionBody = 'element--container__subdecision__body',
  ContainerSubactionText = 'element--container__subaction__text',
  ContainerSubdecisionText = 'element--container__subdecision__text',
  ContainerSubcomponentText = 'element--container__subcomponent__text',
  ContainerHeaderBody = 'element--container__header__body',
  ContainerHeaderText = 'element--container__header__text',
  ContainerSelectionBehaviourBody = 'element--selectionbehavior--container__body',
  ContainerSelectionBehaviourText = 'element--selectionbehavior--container__text',
}
